// These are the metrics required to format Nunito text correctly.
const nunitoMetrics = {
    capHeight: 705,
    ascent: 1011,
    descent: -353,
    lineGap: 0,
    unitsPerEm: 1000,
};

export const widgetTheme = () => {
    return {
        TextBlock: {
            fontFamily: "Nunito",
            fontMetrics: nunitoMetrics,
            sizes: {
                xxsmall: {
                    fontSize: 12,
                    lineGap: 8,
                },
                xsmall: {
                    fontSize: 13,
                    lineGap: 9,
                },
                small: {
                    fontSize: 14,
                    lineGap: 10,
                },
                standard: {
                    fontSize: 16,
                    lineGap: 12,
                },
                medium: {
                    fontSize: 16,
                    lineGap: 12,
                },
                large: {
                    fontSize: 18,
                    lineGap: 20,
                },
                xlarge: {
                    fontSize: 22,
                    lineGap: 26,
                },
                xxlarge: {
                    fontSize: 26,
                    lineGap: 30,
                },
            },
        },
        Heading: {
            fontFamily: "Nunito",
            fontMetrics: nunitoMetrics,
            sizes: {
                xxsmall: {
                    fontSize: 18,
                    lineGap: 20,
                },
                xsmall: {
                    fontSize: 20,
                    lineGap: 21,
                },
                small: {
                    fontSize: 24,
                    lineGap: 25,
                },
                standard: {
                    fontSize: 26,
                    lineGap: 24,
                },
                medium: {
                    fontSize: 26,
                    lineGap: 24,
                },
                large: {
                    fontSize: 32,
                    lineGap: 28,
                },
                xlarge: {
                    fontSize: 48,
                    lineGap: 36,
                },
                xxlarge: {
                    fontSize: 64,
                    lineGap: 52,
                },
            },
        },
    };
};
